import { DataGrid, Grid, Paper } from "@pankod/refine-mui";
import React, { useState, useEffect } from "react";
import HeaderFunnel from "./HeaderFunnel";

function StatisticheFunnel() {
  const [data, setData] = useState(undefined);
  const [rows, setRows] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      //remove site_views from the object
      const site_views = data.site_views;
      delete data.site_views;

      // Transform your object into an array of rows
      const stats = Object.keys(data).map((hotelName, index) => ({
        id: index, // Each row must have a unique id field
        hotel: hotelName,
        ...data[hotelName], // Spread the facility-view, cart-add, checkout-start, checkout-end fields
      }));

      //add extra final row with total
      const totals = {
        id: stats.length,
        hotel: "Totale",
        site_views: site_views,
      };
      // Retrieve the keys dynamically from the first hotel object (excluding the "hotel" key)
      const statKeys = Object.keys(stats[0]).filter(
        (key) => key !== "id" && key !== "hotel"
      );

      // Initialize totals for all dynamic keys with 0
      statKeys.forEach((key) => {
        totals[key] = 0;
      });
      // Calculate totals for each field
      stats.forEach((item) => {
        statKeys.forEach((key) => {
          totals[key] += item[key];
        });
      });

      // put the total row at the beginning of the stats array
      stats.unshift(totals);

      setRows(stats);
      console.log(stats);
    }
  }, [data]);

  const columnsStatistiche = [
    {
      field: "hotel",
      headerName: "Hotel",
      minWidth: 150,
      //flex: 1,
    },
    {
      field: "site_views",
      //headerName: "Visualizzazioni homepage",
      renderHeader: () => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            textAlign: "center",
            lineHeight: "16pt",
          }}
        >
          Visualizzazioni homepage
        </div>
      ),
      minWidth: 150,
      //flex: 1,
    },
    {
      field: "facility-view",
      //headerName: "Visualizzazioni schede hotel",
      renderHeader: () => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            textAlign: "center",
            lineHeight: "16pt",
          }}
        >
          Visualizzazioni schede hotel
        </div>
      ),
      minWidth: 120,
      flex: 1,
    },
    {
      field: "cart-add",
      headerName: "Interazioni carrello",
      minWidth: 80,
      flex: 1,
    },
    {
      field: "checkout-end",
      headerName: "Checkout",
      minWidth: 80,
      flex: 1,
    },
    {
      field: "bookings",
      headerName: "Prenotazioni",
      minWidth: 80,
      flex: 1,
    },
    {
      field: "cancellations",
      headerName: "Cancellazioni",
      minWidth: 80,
      flex: 1,
    },
  ];

  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderFunnel setData={setData} setLoading={setLoading} />
        </Grid>
        <Grid item xs={12}>
          {rows && (
            <DataGrid
              rows={rows}
              getRowId={(row) => row?.hotel}
              columns={columnsStatistiche}
              pageSize={rows?.length}
              pagination
              components={{
                Pagination: () => {
                  return null;
                },
              }}
              autoHeight
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage === 0 //rows.length - 1
                  ? "first-row"
                  : ""
              }
              sx={{
                border: "none",
                "& .MuiDataGrid-columnHeaders": {
                  background: "rgb(242, 242, 242)",
                  borderBottom: "1px solid rgb(229, 229, 229)",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid rgb(242, 242, 242)",
                },
                "& .first-row": {
                  backgroundColor: "#f8f8f8",
                  fontWeight: "bold",
                },
              }}
              disableSelectionOnClick={true}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default StatisticheFunnel;
